module.exports = __webpack_public_path__ + "img/longitude.03f96727.svg";